export const aiReadinessQuestions = [
  {
    category: "Awareness",
    questions: [
      {
        id: "q1",
        text: "How familiar are you with AI tools like ChatGPT, Microsoft Copilot, or Google Gemini?",
        options: [
          { label: "Never heard of them", score: 0 },
          { label: "Heard of them, never tried", score: 1 },
          { label: "Tried once or twice", score: 2 },
          { label: "Use them occasionally", score: 3 },
          { label: "Use them regularly", score: 4 },
        ],
      },
      {
        id: "q2",
        text: "Have you ever used AI to help with a business task (writing, scheduling, customer replies, etc.)?",
        options: [
          { label: "Never", score: 0 },
          { label: "Once or twice", score: 1 },
          { label: "A few times", score: 2 },
          { label: "Monthly", score: 3 },
          { label: "Weekly or daily", score: 4 },
        ],
      },
    ],
  },
  {
    category: "Infrastructure",
    questions: [
      {
        id: "q3",
        text: "What devices does your team primarily use for work?",
        options: [
          { label: "Basic phones only", score: 0 },
          { label: "Smartphones only", score: 1 },
          { label: "Shared computers", score: 2 },
          { label: "Individual laptops/PCs", score: 3 },
          { label: "Full digital setup", score: 4 },
        ],
      },
      {
        id: "q4",
        text: "How reliable is your internet connection at your business location?",
        options: [
          { label: "Very unreliable", score: 0 },
          { label: "Often drops", score: 1 },
          { label: "Adequate", score: 2 },
          { label: "Good", score: 3 },
          { label: "Excellent and consistent", score: 4 },
        ],
      },
      {
        id: "q5",
        text: "Which digital tools does your business currently use?",
        options: [
          { label: "None", score: 0 },
          { label: "WhatsApp Business only", score: 1 },
          { label: "Google Workspace", score: 2 },
          { label: "Microsoft 365", score: 3 },
          { label: "Multiple integrated tools", score: 4 },
        ],
      },
    ],
  },
  {
    category: "Processes",
    questions: [
      {
        id: "q6",
        text: "How much of your daily admin work (emails, reports, scheduling) is done manually?",
        options: [
          { label: "Almost everything", score: 0 },
          { label: "Most tasks", score: 1 },
          { label: "About half", score: 2 },
          { label: "A small portion", score: 3 },
          { label: "Almost nothing", score: 4 },
        ],
      },
      {
        id: "q7",
        text: "Do you have written SOPs (Standard Operating Procedures) for your key business tasks?",
        options: [
          { label: "No procedures at all", score: 0 },
          { label: "Informal verbal notes", score: 1 },
          { label: "Some partial documents", score: 2 },
          { label: "Mostly documented", score: 3 },
          { label: "Fully documented", score: 4 },
        ],
      },
      {
        id: "q8",
        text: "How often do repetitive tasks (copy-paste, re-typing data, same emails) slow your team down?",
        options: [
          { label: "Every day, significantly", score: 0 },
          { label: "Most days", score: 1 },
          { label: "Sometimes", score: 2 },
          { label: "Rarely", score: 3 },
          { label: "Almost never", score: 4 },
        ],
      },
    ],
  },
  {
    category: "People",
    questions: [
      {
        id: "q9",
        text: "How confident is your team about learning and using new digital tools?",
        options: [
          { label: "Very resistant to change", score: 0 },
          { label: "Hesitant", score: 1 },
          { label: "Neutral", score: 2 },
          { label: "Generally open", score: 3 },
          { label: "Enthusiastic adopters", score: 4 },
        ],
      },
      {
        id: "q10",
        text: "How would you rate your own confidence using technology for business tasks?",
        options: [
          { label: "Not confident at all", score: 0 },
          { label: "Slightly confident", score: 1 },
          { label: "Moderately confident", score: 2 },
          { label: "Confident", score: 3 },
          { label: "Very confident", score: 4 },
        ],
      },
      {
        id: "q11",
        text: "Do you have anyone who handles IT or digital systems for your business?",
        options: [
          { label: "No one at all", score: 0 },
          { label: "I handle it myself", score: 1 },
          { label: "Occasional outside help", score: 2 },
          { label: "Part-time support", score: 3 },
          { label: "Dedicated IT person", score: 4 },
        ],
      },
    ],
  },
  {
    category: "Data & Content",
    questions: [
      {
        id: "q12",
        text: "How often does your business produce written content (emails, social posts, proposals, reports)?",
        options: [
          { label: "Rarely or never", score: 0 },
          { label: "Monthly", score: 1 },
          { label: "Weekly", score: 2 },
          { label: "Several times per week", score: 3 },
          { label: "Daily", score: 4 },
        ],
      },
      {
        id: "q13",
        text: "Does your business collect or store customer data (contacts, purchase history, feedback)?",
        options: [
          { label: "Not at all", score: 0 },
          { label: "On paper only", score: 1 },
          { label: "Basic spreadsheet", score: 2 },
          { label: "Simple digital system", score: 3 },
          { label: "Organised CRM or database", score: 4 },
        ],
      },
      {
        id: "q14",
        text: "How often does slow or missing information cause delays in your business?",
        options: [
          { label: "Very frequently", score: 0 },
          { label: "Often", score: 1 },
          { label: "Sometimes", score: 2 },
          { label: "Rarely", score: 3 },
          { label: "Almost never", score: 4 },
        ],
      },
    ],
  },
  {
    category: "Strategy",
    questions: [
      {
        id: "q15",
        text: "How important is improving efficiency and reducing costs to your business right now?",
        options: [
          { label: "Not a priority", score: 0 },
          { label: "Somewhat important", score: 1 },
          { label: "Important", score: 2 },
          { label: "Very important", score: 3 },
          { label: "Critical priority", score: 4 },
        ],
      },
      {
        id: "q16",
        text: "Are you willing to invest time (even if not money) to test AI tools over the next 30 days?",
        options: [
          { label: "Definitely not", score: 0 },
          { label: "Unlikely", score: 1 },
          { label: "Maybe", score: 2 },
          { label: "Probably yes", score: 3 },
          { label: "Absolutely yes", score: 4 },
        ],
      },
      {
        id: "q17",
        text: "Compared to your competitors, how advanced is your business in using technology?",
        options: [
          { label: "Far behind", score: 0 },
          { label: "Somewhat behind", score: 1 },
          { label: "About the same", score: 2 },
          { label: "Slightly ahead", score: 3 },
          { label: "Leading the way", score: 4 },
        ],
      },
    ],
  },
  {
    category: "Customer",
    questions: [
      {
        id: "q18",
        text: "How do customers primarily contact your business?",
        options: [
          { label: "Walk-in only", score: 0 },
          { label: "Phone calls mainly", score: 1 },
          { label: "Mix of phone and WhatsApp", score: 2 },
          { label: "WhatsApp and email", score: 3 },
          { label: "Multiple digital channels", score: 4 },
        ],
      },
      {
        id: "q19",
        text: "How long does it typically take to respond to a customer enquiry?",
        options: [
          { label: "Over 24 hours", score: 0 },
          { label: "Same day, hours later", score: 1 },
          { label: "Within a few hours", score: 2 },
          { label: "Within 1 hour", score: 3 },
          { label: "Almost instantly", score: 4 },
        ],
      },
      {
        id: "q20",
        text: "Do you currently use any automation for customer communication (auto-replies, chatbots, templates)?",
        options: [
          { label: "Nothing automated", score: 0 },
          { label: "Basic away message only", score: 1 },
          { label: "Some reply templates", score: 2 },
          { label: "Moderate automation", score: 3 },
          { label: "Extensive automation", score: 4 },
        ],
      },
    ],
  },
];

export const aiMaturityTiers = [
  {
    min: 0,
    max: 19,
    label: "AI Beginner",
    description: "Starting line — free tools can help immediately",
  },
  {
    min: 20,
    max: 39,
    label: "AI Explorer",
    description: "Foundations in place — 30-day plan will unlock big wins",
  },
  {
    min: 40,
    max: 55,
    label: "AI Adopter",
    description: "Well-positioned — systematise and expand",
  },
  {
    min: 56,
    max: 69,
    label: "AI Practitioner",
    description: "Strong readiness — measure ROI and train your team",
  },
  {
    min: 70,
    max: 80,
    label: "AI Leader",
    description: "Exceptional — focus on competitive differentiation",
  },
];

export const industryOptions = [
  "Technology",
  "Healthcare",
  "Finance / Banking",
  "Retail / E-commerce",
  "Manufacturing",
  "Education",
  "Real Estate",
  "Hospitality / Tourism",
  "Transportation / Logistics",
  "Agriculture",
  "Legal / Professional Services",
  "Media / Entertainment",
  "Construction",
  "Energy / Utilities",
  "Non-profit / NGO",
  "Government / Public Sector",
  "Other",
];

export const companySizeOptions = [
  "1 (Solo founder)",
  "2-5 employees",
  "6-20 employees",
  "21-50 employees",
  "51-200 employees",
  "200+ employees",
];